import React from 'react';

const FileManagerPage = () => (
  <div>
    <h2>File Manager</h2>
    <p>Upload, view, and manage files here.</p>
  </div>
);

export default FileManagerPage;